import { ITEM_TYPES, OUTCOMES } from '../config.js';
import {
    badBurst,
    isMuted,
    popBurst,
    popTone,
    tone,
    toneSequence,
    unlockAudio,
} from './sfxCore.js';

let badItemFileUrl = null;
/** @type {HTMLAudioElement | null} */
let badItemAudio = null;

function playFile(url) {
    let audio = badItemAudio;
    if (!audio || audio.src !== url) {
        audio = new Audio(url);
        audio.preload = 'auto';
        badItemAudio = audio;
    }

    audio.currentTime = 0;
    audio.play().catch(() => {});
}

function playProceduralBadItem() {
    badBurst({ rootHz: 480, gain: 0.115 });
}

/**
 * Register a URL to replace the procedural bad-item (error) sound.
 * @param {string} url
 */
export function registerBadItemSoundAsset(url) {
    badItemFileUrl = url || null;
    badItemAudio = null;
}

export function clearBadItemSoundAsset() {
    badItemFileUrl = null;
    badItemAudio = null;
}

export function getBadItemSoundAsset() {
    return badItemFileUrl;
}

/** Short tick during intro countdown (respects mute). */
export function playIntroCountdownTick() {
    if (isMuted()) return;
    unlockAudio();
    tone({
        startHz: 620,
        endHz: 900,
        durationMs: 70,
        type: 'sine',
        gain: 0.055,
    });
}

/** “Go” sting when the intro banner opens the round. */
export function playIntroGo() {
    if (isMuted()) return;
    unlockAudio();
    toneSequence([
        { startHz: 420, endHz: 680, durationMs: 90, type: 'triangle', gain: 0.07 },
        { startHz: 680, endHz: 980, durationMs: 120, delayMs: 70, type: 'sine', gain: 0.08 },
    ]);
}

function playVictoryStinger() {
    toneSequence([
        { startHz: 392, endHz: 392, durationMs: 90, type: 'sine', gain: 0.065 },
        { startHz: 494, endHz: 494, durationMs: 90, delayMs: 85, type: 'sine', gain: 0.07 },
        { startHz: 587, endHz: 587, durationMs: 100, delayMs: 170, type: 'triangle', gain: 0.075 },
        { startHz: 784, endHz: 784, durationMs: 220, delayMs: 260, type: 'sine', gain: 0.085 },
        { startHz: 988, endHz: 1175, durationMs: 280, delayMs: 460, type: 'triangle', gain: 0.055 },
    ]);
    window.setTimeout(() => popBurst({ rootHz: 720, gain: 0.09 }), 480);
    window.setTimeout(() => popBurst({ rootHz: 880, delayMs: 0, gain: 0.07 }), 620);
}

function playDefeatStinger() {
    toneSequence([
        { startHz: 196, endHz: 147, durationMs: 320, type: 'sawtooth', gain: 0.055 },
        { startHz: 147, endHz: 98, durationMs: 380, delayMs: 240, type: 'triangle', gain: 0.07 },
        { startHz: 110, endHz: 55, durationMs: 520, delayMs: 520, type: 'sine', gain: 0.08 },
    ]);
    popTone({
        startHz: 90,
        endHz: 42,
        durationMs: 480,
        delayMs: 400,
        type: 'sawtooth',
        gain: 0.045,
    });
}

function playSkippedStinger() {
    toneSequence([
        { startHz: 440, endHz: 370, durationMs: 200, type: 'sine', gain: 0.05 },
        { startHz: 330, endHz: 262, durationMs: 240, delayMs: 180, type: 'triangle', gain: 0.045 },
    ]);
}

/**
 * Result overlay sting — celebration vs game over.
 * @param {'finished' | 'died' | 'skipped' | null | undefined} outcome
 */
export function playResultStinger(outcome) {
    if (isMuted()) return;
    unlockAudio();

    if (outcome === OUTCOMES.DIED) {
        playDefeatStinger();
        return;
    }

    if (outcome === OUTCOMES.SKIPPED) {
        playSkippedStinger();
        return;
    }

    playVictoryStinger();
}

/** @deprecated Use playResultStinger(OUTCOMES.FINISHED) */
export function playFinishStinger() {
    playResultStinger(OUTCOMES.FINISHED);
}

/** Pop when tapping a lead card (good / hot / bonus). */
export function playLeadHitSound(itemType) {
    if (isMuted()) return;

    unlockAudio();

    if (itemType === ITEM_TYPES.HOT_LEAD) {
        popBurst({ rootHz: 920, gain: 0.115 });
        return;
    }

    if (itemType === ITEM_TYPES.BONUS) {
        popBurst({ rootHz: 1000, gain: 0.12 });
        return;
    }

    popBurst({ rootHz: 800, gain: 0.11 });
}

/** Play error feedback when the player taps a bad item (SPAM, etc.). */
export function playBadItemSound() {
    if (isMuted()) return;

    unlockAudio();

    if (badItemFileUrl) {
        playFile(badItemFileUrl);
        return;
    }

    playProceduralBadItem();
}
